export const DATOS_EXTRA = (data, handleChange, edit, cuentas, permissions) => {
  const cuentasMarcadas =
    cuentas?.map((cuenta) => ({
      ...cuenta,
      disabled: cuenta.activo === 0,
    })) || []

  return [
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'cuentaDebe',
      label: 'Cuenta debe',
      optionValue: 'id',
      options: cuentasMarcadas,
      getOptionDisabled: (option) => option.disabled,
      optionLabel: `options["label"]`,
      value: cuentasMarcadas.find((c) => c.id === data.cuentaDebe)?.id || null,
      disabled: permissions.allowEdit ? !edit : true,
      onChange: (e) => handleChange('cuentaDebe', e.id),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'cuentaHaber',
      label: 'Cuenta haber',
      optionValue: 'id',
      options: cuentasMarcadas,
      getOptionDisabled: (option) => option.disabled,
      optionLabel: `options["label"]`,
      value: cuentasMarcadas.find((c) => c.id === data.cuentaHaber)?.id || null,
      disabled: permissions.allowEdit ? !edit : true,
      onChange: (e) => handleChange('cuentaHaber', e.id),
    },
    {
      class: 'textfield',
      sm: 12,
      xs: 12,
      name: 'notas',
      label: 'Observación',
      value: data.notas,
      disabled: !edit,
      onChange: (e) => handleChange('notas', e.target.value),
    },
  ]
}
